import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpRequestPayload } from '@core/models';
// import { AuthService } from 'src/app/core/services/auth/auth.service';
import { HttpRequest } from '../../models/http-provider.model';

@Injectable({
  providedIn: 'root',
})
export class HttpProviderService {
  // baseURL: string = 'https://www.ifincloud.io';
  // defaultContext = '/dit2-cbx-admin/publisher';
  baseURL: string = '';
  defaultPublisher = '/olive/publisher';
  fileUploadURL: string = '';
  keycloakURL: string = '';
  realm: string = '';
  client: string = '';
  restURL: string = '';
  idleTimeout: number = 0;
  idleTimer: any;
  idleTimeCount: number = 0;
  promptIdleTimeoutB4: number = 30; //in second
  isPromptTimerAlert: boolean = false;
  defaultIdleTimeout: number = 5;

  constructor(
    private httpClient: HttpClient,
    // private _authService: AuthService
  ) {
    // this._getConfig();
  }

  invokeApi(request: HttpRequestPayload): Observable<any> {
    let requestURL = this.baseURL;
    requestURL += request.serverContext
      ? request.serverContext
      : this.defaultPublisher;

    requestURL += request.resource;

    /** append the query params */
    if (request.queryParams) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL += request.queryParams ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      authorization: this.authToken,
    };

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }

  invokeRestApi(httpRequest: HttpRequest): Observable<any> {

    httpRequest.addHeaderParamter('languageCode','en_US');

    let request = httpRequest.httpPayload;
    let requestURL = this.baseURL;
    requestURL += request.serverContext
      ? request.serverContext
      : this.defaultPublisher;

    requestURL += request.resource;

    if (request.pathParams && request.pathParams.length > 0) {
      for (let index = 0; index < request.pathParams.length; index++) {
        requestURL = requestURL.replace(`{${request.pathParams[index].key}}`,request.pathParams[index].value);
      }
    }

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL += request.queryParams && request.queryParams?.length > 0 ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      authorization: this.authToken,
    };

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }

  get authToken(): string {
    // return 'Bearer ' + this._authService.token;
    return 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.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.xmGRpqs-tPmm5X-P6RntNMXSOY08sg4bD9nxOR5LyjA';
  }

  private _getConfig() {
    let origin = '';
    const url = origin + 'assets/config/config.json';
    return this.httpClient.get(url).subscribe((res) => {
      this._refreshVar(res);
    });
  }

  private _refreshVar(data: any) {
    this.baseURL = data.baseURL;
    this.fileUploadURL = data.fileUploadURL;
    this.keycloakURL = data.KEYCLOAK_URL;
    this.realm = data.KEYCLOAK_REALM;
    this.client = data.KEYCLOAK_CLIENT_ID;
    this.restURL = data.baseURL;

    if (data.idleTimeoutInMin)
      this.idleTimeout = parseInt(data.idleTimeoutInMin) * 60;
    else this.idleTimeout = this.defaultIdleTimeout * 60;

    if (data.idleTimeoutPromptB4Sec)
      this.promptIdleTimeoutB4 = parseInt(data.idleTimeoutPromptB4Sec);
    else this.promptIdleTimeoutB4 = 60;

    this._clearTimer();
  }

  private _clearTimer() {
    this.isPromptTimerAlert = false;
    if (this.idleTimer) clearInterval(this.idleTimer);
  }
}
